<template>
  <PageContent type="center" :compClass="'flex flex-col space-y-6'">
    <div class="flex flex-row items-center justify-between">
      <h1 class="text-xl font-semibold">YouTube Analytics</h1>
    </div>
    <div class="flex-col space-y-2">
      <router-link class="grid grid-cols-5 bg-white p-4 rounded-lg group relative cursor-pointer text-gray-900"
        v-for="report in reports" :to="{
          name: 'AdminYoutubeStatisticsReport',
          params: { granularity_id: report.granularity_id }
        }">
        <span class="font-medium text-black">{{ report.start_date | displayMonth }}</span>
        <div class="space-x-2" v-if="report.statistics !== null">
          <i class="fa-solid fa-eye mr-2"></i> {{ report.statistics.views.toLocaleString() }}
        </div>
        <div class="space-x-2" v-if="report.statistics !== null">
          <i class="fa-solid fa-thumbs-up mr-2"></i> {{ report.statistics.likes.toLocaleString() }}
        </div>
        <div class="space-x-2" v-if="report.statistics !== null">
          <i class="fa-solid fa-share mr-2"></i> {{ report.statistics.shares.toLocaleString() }}
        </div>
        <div class="space-x-2" v-if="report.statistics !== null">
          <i class="fa-solid fa-money-bill mr-2"></i> {{ report.total_earnings | displayMoney }}
        </div>
        <div class="col-span-4 flex items-center" v-if="report.reportProgressStatus !== null">
          <div class="flex h-6 w-full bg-gray-200 rounded-full items-center p-1">
            <div
              class="flex bg-gray-600 rounded-full h-full text-xs items-center content-center justify-center text-white"
              :style="{ width: ((report.reportProgressStatus.report_videos / report.reportProgressStatus.total_videos) * 100) + '%' }">
              {{
                Math.round((report.reportProgressStatus.report_videos / report.reportProgressStatus.total_videos) *
                  100)
              }}%
            </div>
          </div>
        </div>
        <div class="absolute right-0 h-full top-0 p-4 transition opacity-0 group-hover:opacity-100">
          <i class="fa-regular fa-circle-arrow-right text-xl leading-none"></i>
        </div>
      </router-link>
    </div>

    <div class="">Users Awaiting Payment</div>

    <div class="-mx-4 mt-8 overflow-hidden shadow-md ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr class="hidden lg:table-row">
            <th scope="col" class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
              User
            </th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              Pending Earnings
            </th>
            <th scope="col" class="hidden relative py-3.5 pl-3 pr-4 sm:pr-6 lg:table-cell">
              <span class="sr-only">View Report</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="user in usersPending" v-bind:key="user.user_id">
            <td scope="col" class="py-3.5 px-3 text-left text-sm text-gray-800">
              {{ user.name }}
              <dl class="font-normal lg:hidden">
                <dd class="mt-1 truncate text-gray-700">
                  {{ user.current_balance | displayMoney }}
                </dd>
              </dl>
            </td>
            <td scope="col" class="hidden px-3 py-3.5 text-left text-sm text-gray-500 lg:table-cell">
              {{ user.current_balance | displayMoney }}
            </td>
            <td class="hidden relative py-3.5 px-3 lg:table-cell text-sm">
              <button class="text-blue-600 hover:text-blue-900"
                v-on:click="$eventBus.$emit('admin-record-social-payment-open-modal', user)">Record Payment</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <SocialRecordPayment />
  </PageContent>
</template>

<script>
import * as Config from "@/config";
import moment from "moment";
import PageContent from "@/components/PageContent";
import StatCard from "@/components/StatCard";
import SocialRecordPayment from "@/screens/admin/modals/SocialRecordPayment"


export default {
  name: "YouTubeStatisticsReports",
  data() {
    return {
      reports: [],
      usersPending: [],
    };
  },
  components: {
    PageContent,
    StatCard,
    SocialRecordPayment
  },
  mounted() {
    this.getAnalyticsReports();
    this.getUsersAwaitingPayment();

    this.$nextTick(
      function () {
        this.$eventBus.$on("admin-payment-recorded-refresh-data", this.getUsersAwaitingPayment);
      }.bind(this)
    );
  },
  methods: {
    async getAnalyticsReports() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/youtube/reports",
      );
      this.reports = res.data
    },
    async getUsersAwaitingPayment() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/youtube/pending_payment",
      );
      this.usersPending = res.data
    },
  },
  filters: {
    displayMonth: function (datetime) {
      return moment.utc(datetime).format('MMMM Y')
    },
    displayMoney: function (value) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });
      return formatter.format(value);
    },
  }
};
</script>
